<div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" (change)="onForm()">
    <div *ngFor="let field of fields" class="form-row form-holder">
      <app-form-inputs [field]="field" [form]="form" class="w-100" (customEvent)= "customChange($event)"></app-form-inputs>
    </div>
  </form>
</div>
